/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Success_ToastInputs */

const en_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy import completed successfully`)
};

const fr_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du proxy terminee avec succes`)
};

const de_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Import erfolgreich abgeschlossen`)
};

const it_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione proxy completata con successo`)
};

const ru_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт через прокси успешно завершен.`)
};

const es_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación del proxy se completó correctamente`)
};

const zh_cn2_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理导入已成功完成`)
};

const ja_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシのインポートが正常に完了しました`)
};

const hi_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी आयात सफलतापूर्वक पूरा हो गया`)
};

const pt_pt2_iconik_proxy_success_toast = /** @type {(inputs: Iconik_Proxy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de proxy concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Proxy import completed successfully" |
*
* @param {Iconik_Proxy_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_success_toast = /** @type {((inputs?: Iconik_Proxy_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_success_toast(inputs)
	if (locale === "de") return de_iconik_proxy_success_toast(inputs)
	if (locale === "it") return it_iconik_proxy_success_toast(inputs)
	if (locale === "ru") return ru_iconik_proxy_success_toast(inputs)
	if (locale === "es") return es_iconik_proxy_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_success_toast(inputs)
	if (locale === "ja") return ja_iconik_proxy_success_toast(inputs)
	if (locale === "hi") return hi_iconik_proxy_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_success_toast(inputs)
	return en_iconik_proxy_success_toast(inputs)
});